import { render, staticRenderFns } from "./productinfo.vue?vue&type=template&id=799a3396&scoped=true&"
import script from "./productinfo.vue?vue&type=script&lang=js&"
export * from "./productinfo.vue?vue&type=script&lang=js&"
import style0 from "./productinfo.vue?vue&type=style&index=0&id=799a3396&prod&lang=scss&"
import style1 from "./productinfo.vue?vue&type=style&index=1&id=799a3396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a3396",
  null
  
)

export default component.exports